import { render, staticRenderFns } from "./court-info-cn.vue?vue&type=template&id=25017107&"
import script from "./court-info-cn.vue?vue&type=script&lang=js&"
export * from "./court-info-cn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports